var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'tui-search-input-container',
    !_setup.isPC && 'tui-search-input-container-h5',
    _setup.props.searchType === 'global'
      ? 'tui-search-input-container-global'
      : 'tui-search-input-container-conversation',
  ],on:{"click":function($event){return _setup.handleMenu(_setup.extensionList[0])}}},[_c('div',{class:['tui-search-input', !_setup.isPC && 'tui-search-input-h5']},[_c('div',{staticClass:"tui-search-input-left"},[_c(_setup.Icon,{staticClass:"icon",attrs:{"file":_setup.searchIcon,"width":"14px","height":"14px"}})],1),_c('input',{staticClass:"tui-search-input-main",attrs:{"readonly":"","type":"text","placeholder":"联系人","enterkeyhint":"search"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }